import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { formatUrl, formatImage } from '@ifeng/public_method';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import publicStyle from '../public/newsGroup.css';
import { rel as relText } from '../../../utils/rel';
import { classnames } from '../../../utils/classnames';

class NewsGroupComponent extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        componentOptions: PropTypes.object,
        index: PropTypes.number,
    };

    constructor(...argv) {
        super(...argv);

        const { content, componentOptions } = this.props;
        const formatData = this.formatData(content, componentOptions.extendData || [], componentOptions.length || 4);

        this.state = {
            data: formatData,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.content !== nextProps.content) {
            const { content, componentOptions } = nextProps;

            this.setState({
                data: this.formatData(content, componentOptions.extendData || [], componentOptions.length || 4),
            });
        }
    }

    // 判断为视频
    isVideo = item => item.videoCount;

    // 判断为图片
    isImage = item =>
        item.thumbnail ||
        (item.thumbnails &&
            item.thumbnails !== '' &&
            Array.isArray(item.thumbnails.image) &&
            item.thumbnails.image.length > 0);

    // 获取image的url
    getImageUrl(item) {
        if ('picUrl' in item) return item.picUrl;
        else return item.url;
    }

    // 渲染第一行图片
    firstImageRender(firstData) {
        const { thumbnail, url, title } = firstData;
        let img = thumbnail ? thumbnail : null;

        img =
            !img && firstData.thumbnails && firstData.thumbnails.image[0]
                ? this.getImageUrl(firstData.thumbnails.image[0])
                : img;

        return (
            <div className={styles.firstImageBox}>
                <a className={styles.firstImage} href={url} target="_blank" rel={relText}>
                    <img className={styles.firstImage} src={img} alt={title} />
                </a>
            </div>
        );
    }

    // 渲染列表
    newsView(list) {
        const {
            content,
            componentOptions: { extendData },
        } = this.props;
        let topType = null; // 第一个的类型：video或image
        let topIndex = null; // 第一个的索引

        // 有混合数据时，把混合数据放在最上面
        if (content.length > 0 && extendData && extendData.length > 0) {
            topIndex = 0;

            if (this.isVideo(list[0])) topType = 'video';
            else if (this.isImage(list[0])) topType = 'image';
            else topType = null;
        } else {
            for (let i = 0, j = list.length; i < j; i++) {
                const item = list[i];

                if (this.isVideo(item) && topType === null) {
                    topType = 'video';
                    topIndex = i;
                } else if (this.isImage(item) && topType === null) {
                    topType = 'image';
                    topIndex = i;
                }
            }
        }

        // 排序
        if (topIndex !== null && topIndex > 0) {
            const top = list[topIndex];

            list.splice(topIndex, 1);
            list.unshift(top);
        }

        return list.map((item, index) => {
            const key = item.id;
            const url = item.notFormatUrl ? item.url : formatUrl(item.url);

            // 渲染视频模式
            if (index === 0 && topType === 'video') {
                const { thumbnail } = item;
                let img = thumbnail ? thumbnail : null;

                img =
                    !img && item.thumbnails && item.thumbnails.image[0]
                        ? this.getImageUrl(item.thumbnails.image[0])
                        : img;

                return (
                    <li key={key} className={`${styles.has_image} clearfix`}>
                        <a className={styles.image_link} href={url} title={item.title} target="_blank" rel={relText}>
                            <img
                                src={img ? formatImage(img, 98, 54) : undefined}
                                alt={item.title}
                                width={98}
                                height={54}
                            />
                            <div className={styles.play} />
                        </a>
                        <h5 className={styles.image_title}>
                            <a href={url} title={item.title} target="_blank" rel={relText}>
                                {item.title}
                            </a>
                        </h5>
                    </li>
                );
            }

            // 渲染图片模式
            if (index === 0 && topType === 'image') {
                const { thumbnail } = item;
                let img = thumbnail ? thumbnail : null;

                img =
                    !img && item.thumbnails && item.thumbnails.image[0]
                        ? this.getImageUrl(item.thumbnails.image[0])
                        : img;

                return (
                    <li key={key} className={`${styles.has_image} clearfix`}>
                        <a className={styles.image_link} href={url} title={item.title} target="_blank" rel={relText}>
                            <img
                                src={img ? formatImage(img, 98, 54) : undefined}
                                alt={item.title}
                                width={98}
                                height={54}
                            />
                        </a>
                        <h5 className={styles.image_title}>
                            <a href={url} title={item.title} target="_blank" rel={relText}>
                                {item.title}
                            </a>
                        </h5>
                    </li>
                );
            }

            // 无图
            return (
                <li key={key} className={styles.no_image}>
                    <a href={url} title={item.title} target="_blank" rel={relText}>
                        {item.title}
                    </a>
                </li>
            );
        });
    }

    // 数据处理
    formatData(data = [], extendData = [], length = 4) {
        let dLen = length;

        // 先计算extendData内的数据
        const extendDataResult = [];

        for (const item of extendData) {
            dLen = length - item.data.length;

            for (const item2 of item.data) extendDataResult.push(item2);
        }

        // 主数据至少为1条
        if (dLen <= 0) dLen = 1;

        const mainData = [];

        for (let i = 0, j = dLen > data.length ? data.length : dLen; i < j; i++) mainData.push(data[i]);

        return mainData.concat(extendDataResult).slice(0, length);
    }

    render() {
        const {
            componentOptions,
            componentOptions: { infoTitle, infoUrl, ad, firstImageLink },
            index,
        } = this.props;
        const { data } = this.state;
        const firstData = firstImageLink ? data[0] : null;
        const listData = firstImageLink ? data.slice(1) : data;

        let dataKey = null;
        let adContent = null;

        if (ad && typeof window === 'object') {
            dataKey = componentOptions.dataKey || 'allData';
            adContent = window[dataKey][ad];
        }

        return (
            <div className={publicStyle.news_group}>
                {/* 标题 */}
                <div className={`${publicStyle.news_group_title} clearfix`}>
                    <i className={classnames(publicStyle.block, 'block')} />
                    <span className={publicStyle.link_title}>{infoTitle}</span>
                    {infoUrl ? (
                        <a className={publicStyle.more} href={infoUrl} target="_blank" rel={relText}>
                            更多&gt;
                        </a>
                    ) : null}
                    {ad ? <Ad styleName={styles.ad} content={adContent} /> : null}
                </div>
                {firstImageLink ? this.firstImageRender(firstData) : null}
                {/* 新闻 */}
                <ul className={classnames(styles.news_list, 'news_list')} id={`aside_${index}_list`}>
                    {this.newsView(listData)}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(NewsGroupComponent);
